<template>
  <v-dialog max-width="600" persistent v-model="dialog">
    <v-card flat class="mx-auto colorDominant" max-width="600">
      <v-toolbar flat tile class="colorDominant">
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span class="font-weight-black title ml-6 py-4"></span>
      </v-toolbar>
      <v-card-text
        class="text-center headline font-weight-light px-10 mt-4 pb-10"
      >
        <div>
          <v-icon class="dice" style="font-size: 80px">
            mdi-dice-{{ Math.ceil(Math.random() * 5) + 1 }}
          </v-icon>
        </div>
        <div class="mt-3">
          <h6 class="white--text">
            {{ $t("toPlayInTheCasinoRegistorOrLogin") }}
          </h6>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-4">
        <v-spacer></v-spacer>
        <div id="dialogRegisterBtn" @click.capture="closeDialog">
          <DialogRegister idDialog="unloggedDialog" :urlRedirect="game.redirectUrl" />
        </div>
        <div id="loginBtn" @click.capture="closeDialog">
          <Login :urlRedirect="game.redirectUrl" />
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";

export default {
  props: ["dialog", "game"],

  components: { Login, DialogRegister },

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
